// NOTE: getQuestionType hanya untuk tipe soal (field: type)
export const getNonInteractiveQuestionType = (item) => {
  switch (item?.type) {
    case 'fill_in_the_blanks':
      return 'Isian Singkat';
    case 'multiple_choice':
      return 'Pilihan Ganda';
    case 'sentence_arrangement':
      return 'Susunan Kalimat';
    default:
      return 'Other';
  }
};

// NOTE: getInteractiveType hanya untuk tipe interaktif (field: interactive_type)
export const getInteractiveType = (item) => {
  if (!item?.interactive_type) return 'Other';

  // clickable_type bisa ada di root (item.clickable_type) atau nested (item.interactive_detail[0].clickable_type)
  const clickableType = item?.clickable_type ?? item?.interactive_detail?.[0]?.clickable_type;

  switch (item.interactive_type) {
    case 'pie_chart':
      return 'Pie Chart';
    case 'bar_chart':
      return 'Bar Chart';
    case 'line_chart':
      return 'Line Chart';
    case 'sequential':
      return 'Sambung Titik Berurutan';
    case 'clickable':
      return `Pola Bentuk (${clickableType === 'triangle' ? 'Segitiga' : clickableType === 'box' ? 'Persegi' : clickableType === 'boxhard' ? 'Persegi Kompleks' : 'Other'})`;
    case 'dragpin':
      return 'Penempatan (Drag Pin)';
    default:
      return 'Other';
  }
};

// NOTE: getQuestionType bersifat dinamis:
// - kalau interactive_type ada => pakai tipe interaktif
// - kalau tidak ada => pakai tipe soal (non-interactive)
export const getQuestionType = (item) => {
  if (item?.interactive_type) return getInteractiveType(item);
  return getNonInteractiveQuestionType(item);
};